import { render, staticRenderFns } from "./StudyCardEdit.vue?vue&type=template&id=8665b558&scoped=true&"
import script from "./StudyCardEdit.vue?vue&type=script&lang=js&"
export * from "./StudyCardEdit.vue?vue&type=script&lang=js&"
import style0 from "./StudyCardEdit.vue?vue&type=style&index=0&id=8665b558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8665b558",
  null
  
)

export default component.exports